import { IAppDashboard } from 'core-client/api';

export interface IDashboardGroups {
  /** Published, role-assignable dashboards (the "Standard" group). */
  standard: IAppDashboard[];
  /** Unpublished role-assignable dashboards plus all non-role-assignable dashboards. */
  personal: IAppDashboard[];
}

/**
 * Splits dashboards into the published-standard group and the personal group.
 * Mirrors the split used by the dashboard overview dialog.
 */
export function splitDashboards(dashboards: IAppDashboard[]): IDashboardGroups {
  return {
    standard: dashboards.filter((d: IAppDashboard) => !!d.isPublished && d.roleAssignable),
    personal: dashboards.filter(
      (d: IAppDashboard) => (!d.isPublished && d.roleAssignable) || !d.roleAssignable,
    ),
  };
}
